import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

interface TopNavBarProps {
  canGoBack?: boolean;
  title?: string;
  children?: React.ReactNode;
  isProfileVisible?: boolean;
  rightIcon?: React.ReactNode;
  onRightIconClick?: () => void;
  onBackClick?: () => void;
}

const TopNavBar = ({ canGoBack, title, children, isProfileVisible, rightIcon, onRightIconClick, onBackClick }: TopNavBarProps) => {
  return (
    <>
      {(canGoBack || title) && (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
          <Box
            sx={{
            
              mb: '2px',
              display: 'flex',
              alignItems: 'center',
                mt:'16px'
            }}
          >
            {canGoBack && (
              <IconButton
                onClick={onBackClick || (() => window.history.back())}
                sx={{
                  backgroundColor: 'transparent',
                  borderRadius: '50%',
                  ml:'4px',
                
                  // mr: title ? 1 : 0
                }}
              >
                <ArrowBack sx={{ color: 'black', fontSize: '22px' }} />
              </IconButton>
            )}
            {title && (
              <Typography sx={{ ml: canGoBack ? 1 : 0 ,fontSize: '22px', fontWeight: 500}}>
                {title}
              </Typography>
            )}
            {children}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {isProfileVisible && 
              <Avatar sx={{ width: 30, height: 30 }} />
            }
            {rightIcon && (
              <IconButton
                onClick={onRightIconClick}
                sx={{
                  backgroundColor: 'transparent',
                  borderRadius: '50%',
                  p: 1
                }}
              >
                {rightIcon}
              </IconButton>
            )}
          </Box>
        </Stack>
      )}   
      </>

  )
}

export default TopNavBar